import { cn } from '../utils';

type Props = {
  asset:
    | {
        code: string;
        name: string;
        icon: string | undefined;
      }
    | undefined;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  showName?: boolean;
  nameClassName?: string;
  textClassName?: string;
  leverage?: string;
};

const AssetBaseInfo = ({
  asset,
  className,
  iconClassName,
  labelClassName,
  showName = true,
  nameClassName,
  textClassName,
  leverage,
}: Props) => {
  if (!asset) {
    return null;
  }

  const { code, name, icon } = asset;

  return (
    <div className={cn('flex items-center gap-[1.6rem]', className)}>
      {icon && (
        <img
          className={cn('w-[4.4rem] h-[4.4rem] rounded-full', iconClassName)}
          src={icon}
          alt={name}
        />
      )}
      <div className={cn('overflow-hidden', textClassName)}>
        <h4
          className={cn(
            'headline4 text-primary whitespace-normal break-words',
            labelClassName
          )}>
          {code}
          {leverage && <span className="p3 text-primary"> {leverage}</span>}
        </h4>
        {showName && (
          <p className={cn('p5 text-secondary', nameClassName)}>{name}</p>
        )}
      </div>
    </div>
  );
};

export { AssetBaseInfo };
